export const INVENTORY_ALL_CABANG_GET_REQUEST =
  "INVENTORY_ALL_CABANG_GET_REQUEST";
export const INVENTORY_ALL_CABANG_GET_SUCCESS =
  "INVENTORY_ALL_CABANG_GET_SUCCESS";
export const INVENTORY_ALL_CABANG_GET_FAIL = "INVENTORY_ALL_CABANG_GET_FAIL";
export const INVENTORY_ALL_CABANG_GET_RESET = "INVENTORY_ALL_CABANG_GET_RESET";
